import { render, staticRenderFns } from "./ManageSalesLeads.vue?vue&type=template&id=e2493a14&scoped=true&"
import script from "./ManageSalesLeads.vue?vue&type=script&lang=js&"
export * from "./ManageSalesLeads.vue?vue&type=script&lang=js&"
import style0 from "./ManageSalesLeads.vue?vue&type=style&index=0&id=e2493a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2493a14",
  null
  
)

export default component.exports